import {createAction, props} from "@ngrx/store";
import {NotificationDetailDto} from "@dto/notification-detail/notification-detail.dto";
import {NullableType} from "@type/nullable.type";

const state = "[Notification detail]"

export const initNotificationDetail = createAction(
  `${state} Init notification detail`,
  props<{ sourceId: string }>()
)

export const initNotificationDetailSuccess = createAction(
  `${state} Init notification detail success`,
  props<{ data: NullableType<NotificationDetailDto> }>()
)

export const initNotificationDetailFailure = createAction(
  `${state} Init notification detail failure`,
  props<{ error: string }>()
)
